import moment from 'moment'
import Pikaday from 'pikaday'
import Helpers from '../../modules/Helpers'

const DATE_FORMAT = 'ddd D MMM YY'

if (document.getElementById('alertRequirements') !== undefined) {
    
    const dateFrom = new Pikaday({
        field: document.getElementsByClassName('my-classic__alerts-date--from')[0],
        minDate: new Date(),
        maxDate: moment().add(2, 'years').subtract(7, 'days').toDate(),
        format: DATE_FORMAT,
        firstDay: 1
    })

    const dateTo = new Pikaday({
        field: document.getElementsByClassName('my-classic__alerts-date--to')[0],
        minDate: new Date(),
        maxDate: moment().add(2, 'years').subtract(7, 'days').toDate(),
        format: DATE_FORMAT,
        firstDay: 1
    })

    new Helpers(document.getElementsByClassName('my-classic__alerts-clear-dates')).eventListener((e) => {
        e.preventDefault()
        dateTo.setDate(null)
        dateFrom.setDate(null)
    })
}